export default "__VITE_ASSET__C$x8hglR__"